import _ from 'lodash';

import { SupplementGroupState, SupplementGroupStates } from 'types';
import { core, toJSON } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  supplementGroupStates?: SupplementGroupState[];
  supplementGroupPackageStates?: SupplementGroupStates;
}

const initialState: State = {
  supplementGroupStates: undefined,
  supplementGroupPackageStates: undefined,
};

const getOptionsFromLock = (currentLock: core.TicketGroup): SupplementGroupState[] => {
  const ticketOptionGroups = currentLock.ticketOptionGroup;
  // Sort them by intended ordering. Array.sort is fundamentally a side-effect operation,
  // so let's prefer not to do this inline with the filter below.
  ticketOptionGroups.sort((a, b) => (a.ordering ?? 0) - (b.ordering ?? 0));
  return ticketOptionGroups
    .filter((supplementGroup) => _.isNil(supplementGroup.parentTicketOptionId))
    .map((group) => {
      return {
        id: group.id ?? 0,
        name: group.name ?? '',
        backingMode: group.backingMode,
        isEditing: false,
        isCompleted: false,
        isSkipped: false,
      };
    });
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SUPPLEMENT_GROUPS_SET_STATES: {
      return {
        ...state,
        supplementGroupStates: payload,
      };
    }
    case AppConstants.SUPPLEMENT_GROUPS_PACKAGE_SET_STATES: {
      return {
        ...state,
        supplementGroupPackageStates: {
          ...state.supplementGroupPackageStates,
          [payload.ticketTypeId]: payload.supplementGroupStates,
        },
      };
    }
    case AppConstants.LOCK_TICKETS_DONE: {
      // Initialize the supplement group states.
      const currentLock = toJSON<core.TicketGroup>(payload);

      const supplementGroupStates: SupplementGroupState[] = getOptionsFromLock(currentLock);
      return {
        ...state,
        supplementGroupStates,
      };
    }
    case AppConstants.FETCH_BUSINESS_LOCK_DONE: {
      const currentLock = toJSON<core.TicketGroup>(payload);

      // Initialize the supplement group states.
      const supplementGroupStates: SupplementGroupState[] = getOptionsFromLock(currentLock);
      return {
        ...state,
        supplementGroupStates,
      };
    }
    case AppConstants.LOCK_PACKAGE_DONE: {
      // Initialize the supplement group states.
      const ticketOptionGroups =
        toJSON<core.LockResponse>(payload).lockedTicketSubset?.ticketOptionGroup;

      const supplementGroupStates = _.sortBy(ticketOptionGroups, 'ordering')
        .filter((supplementGroup) => _.isNil(supplementGroup.parentTicketOptionId))
        .map((supplementGroup) => {
          return {
            id: supplementGroup.id as number,
            name: supplementGroup.name ?? '',
            isEditing: false,
            isCompleted: false,
            isSkipped: false,
          };
        });

      const ticketTypeId = payload.lockedTicketSubset.ticketType[0].id as number;
      return {
        ...state,
        supplementGroupPackageStates: {
          ...state.supplementGroupPackageStates,
          [ticketTypeId]: supplementGroupStates,
        },
      };
    }
    default:
      return state;
  }
}
